var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50065 15.833H6.66732C5.09597 15.833 4.3103 15.833 3.82213 16.3212C3.33398 16.8093 3.33398 17.595 3.33398 19.1663V33.333C3.33398 34.9043 3.33398 35.69 3.82213 36.1782C4.3103 36.6663 5.09597 36.6663 6.66732 36.6663H7.50065C9.072 36.6663 9.85767 36.6663 10.3458 36.1782C10.834 35.69 10.834 34.9043 10.834 33.333V19.1663C10.834 17.595 10.834 16.8093 10.3458 16.3212C9.85767 15.833 9.072 15.833 7.50065 15.833Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 7.08301C10.834 9.15407 9.15505 10.833 7.08398 10.833C5.01292 10.833 3.33398 9.15407 3.33398 7.08301C3.33398 5.01194 5.01292 3.33301 7.08398 3.33301C9.15505 3.33301 10.834 5.01194 10.834 7.08301Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.544 15.833H19.1673C17.596 15.833 16.8103 15.833 16.3221 16.3212C15.834 16.8093 15.834 17.595 15.834 19.1663V33.333C15.834 34.9043 15.834 35.69 16.3221 36.1782C16.8103 36.6663 17.596 36.6663 19.1673 36.6663H20.0007C21.572 36.6663 22.3577 36.6663 22.8458 36.1782C23.334 35.69 23.334 34.9043 23.334 33.333L23.3342 27.4998C23.3342 24.7385 24.2142 22.4998 26.8138 22.4998C28.1135 22.4998 29.1673 23.6192 29.1673 24.9998V32.4998C29.1673 34.0712 29.1673 34.8568 29.6555 35.345C30.1435 35.8332 30.9293 35.8332 32.5007 35.8332H33.3318C34.9028 35.8332 35.6883 35.8332 36.1765 35.3452C36.6646 34.8572 36.6648 34.0717 36.6651 32.5007L36.6675 23.3333C36.6675 19.1913 32.728 15.8334 28.8287 15.8334C26.6088 15.8334 24.6285 16.9215 23.3342 18.623C23.334 17.5728 23.334 17.0478 23.106 16.658C22.9615 16.4111 22.7558 16.2056 22.509 16.0611C22.1192 15.833 21.5942 15.833 20.544 15.833Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a6ff83735fcbc2592f6104f9d4e6d29d.svg";
export { ForwardRef as ReactComponent };